// extracted by mini-css-extract-plugin
export var gif = "_kv-0";